import React, { useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const InfoMedalHeader = ({
  medal,
  setOpenState,
  modalRef,
  openMedal,
  setOpenMedal,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleBack = () => {
    setOpenMedal(null);
    // modalRef.current.nextModal(0);
  };

  //? Função para fechar o modal
  const handleClose = () => {
    setOpenState(null);
    setOpenMedal(null);
  };

  useEffect(() => {
    if(!openMedal){
      // console.log("BACCKS")
      modalRef.current.nextModal(0);
    }
  }, [openMedal]);

  return (
    <Box
      sx={{
        maxWidth: "100%",
        width: { xs: "100%", sm: "600px", md: "900px", lg: "1200px" },
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        px: 2,
        py: 1,
        borderRadius: "12px",
        color: "#662d91",
        fontSize: { xs: "16px", sm: "18px", md: "20px" },
        fontWeight: "600",
        lineHeight: "30px",
        position: "relative",
      }}
    >
      <IconButton
        onClick={() => handleBack()}
        sx={{ p: isMobile ? 0.5 : 1 }}
      >
        <ArrowBackIcon
          sx={{ color: "#662d91", fontSize: isMobile ? "20px" : "24px" }}
        />
      </IconButton>

      {/* Nome da atividade com o ícone correspondente */}
      <Typography
        variant="h6"
        sx={{
          display: "flex",
          alignItems: "center",
          ml: isMobile ? 1 : 2,
          mt: isMobile ? 0 : 1,
          fontWeight: "600",
          fontSize: { xs: "14px", sm: "18px", md: "20px" },
          textTransform: "uppercase",
        }}
      >
        Medalha: {medal?.title}
      </Typography>

      {/* Botão de fechar o modal */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          margin: "16px",
          zIndex: 1000,
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            width: { xs: "30px", sm: "37px" },
            height: { xs: "30px", sm: "37px" },
            color: "#662D91",
            border: "solid 2px #662D91",
          }}
        >
          X
        </IconButton>
      </Box>
    </Box>
  );
};

export default InfoMedalHeader;
